@if (!showPreview()) {
  <button
    mat-icon-button
    class="calendar__toggle"
    (click)="showPreview.set(true)"
    [matTooltip]="showPreviewLabel()"
  >
    <mat-icon color="accent">calendar_month</mat-icon>
  </button>
} @else {
  <mat-card class="calendar">
    <mat-card-title class="calendar__title">
      Preview
      <button
        mat-icon-button
        class="calendar__toggle"
        (click)="showPreview.set(false)"
        [matTooltip]="showPreviewLabel()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="calendar__content">
        <div class="calendar__view">
          @if (view() === 'day') {
            @if (isVHF()) {
              <rc-calendar-day-view-beacon
                [selectedDate]="selectedDate()"
                (dayChange)="onDayChange($event)"
                (back)="view.set('month')"
                [scheduleType]="scheduleType()"
              ></rc-calendar-day-view-beacon>
            } @else {
              <rc-calendar-day-view
                [selectedDate]="selectedDate()"
                (dayChange)="onDayChange($event)"
                (back)="view.set('month')"
                [scheduleType]="scheduleType()"
              ></rc-calendar-day-view>
            }
          } @else if (view() === 'month') {
            <rc-calendar-month-view
              (dayChange)="onDayChange($event)"
              (monthChange)="onMonthChange($event)"
              [selectedDate]="selectedDate()"
              (back)="view.set('year')"
              [scheduleType]="scheduleType()"
            ></rc-calendar-month-view>
          } @else if (view() === 'year') {
            <rc-calendar-year-view
              (monthChange)="onMonthChange($event)"
              [selectedDate]="selectedDate()"
              (yearChange)="onYearChange($event)"
              [scheduleType]="scheduleType()"
            ></rc-calendar-year-view>
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>
}
